/* eslint-disable class-methods-use-this */
import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import ItemController from './ItemController';
import { UserAgentManager } from '../manager';

export default class ItemControllerAutoFacingItems extends ItemController {
  /**
    * コンストラクタ
  */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    super(_target);
    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    // 形状の生成
    const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';
    // viewObj.setAttribute("transform", this.target.getCurrentTransform() );
    // 全体のボックス
    this.allBox = new marietta.webcad.control.parts.BoundingBox(viewObj);

    // ピッカー
    this.dragObj_TL = new marietta.webcad.control.parts.ControlPicker(viewObj, 'TL');
    this.dragObj_TL.moveFunc = this.onMoveControlPickerAutoFacingItems;
    this.dragObj_TL.moveEndFunc = this.onMoveEndControlPickerAutoFacingItems;
    this.dragObj_TR = new marietta.webcad.control.parts.ControlPicker(viewObj, 'TR');
    this.dragObj_TR.moveFunc = this.onMoveControlPickerAutoFacingItems;
    this.dragObj_TR.moveEndFunc = this.onMoveEndControlPickerAutoFacingItems;
    this.dragObj_BL = new marietta.webcad.control.parts.ControlPicker(viewObj, 'BL');
    this.dragObj_BL.moveFunc = this.onMoveControlPickerAutoFacingItems;
    this.dragObj_BL.moveEndFunc = this.onMoveEndControlPickerAutoFacingItems;
    this.dragObj_BR = new marietta.webcad.control.parts.ControlPicker(viewObj, 'BR');
    this.dragObj_BR.moveFunc = this.onMoveControlPickerAutoFacingItems;
    this.dragObj_BR.moveEndFunc = this.onMoveEndControlPickerAutoFacingItems;
    // 中心点確認用
    // var center = new marietta.webcad.control.parts.ControlPicker( viewObj, "c" );
    // center.move(0,0);

    const ua: UserAgentManager = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete = new marietta.webcad.control.parts.ButtonGarbage(viewObj, this.target);
      // 反転ボタン
      this.btnReverse = new marietta.webcad.control.parts.ButtonReverse(viewObj, this.target);
      // 移動軸
      this.btnDragger = new marietta.webcad.control.parts.DraggerMobile(viewObj, this.target);
      this.btnDragger.dragFunc = this.onMoveDragger;
      this.btnDragger.dragEndFunc = this.onMoveEndDragger;
    }

    tarLayer.viewObj.appendChild(viewObj);
    this.spt = new SVGSprite(viewObj);
    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
  }

  /**
   *
   */
  initMe() {
    // Todo
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveControlPickerAutoFacingItems = (e: MouseEvent, target: marietta.webcad.control.parts.ControlPicker) => {
    // オーバーライドできるように引き渡す
    this.moveControlPicker(e, target);
    // アイコンボタンの位置更新
    this.updateIconButtons();
  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndControlPickerAutoFacingItems = () => {
    // 階段の場合は、サイズ更新
    if (this.target instanceof marietta.webcad.item.Stair) {
      // ターゲットのリサイズ
      this.resizeTarget();
      this.target.spt.visible = true;
      this.target.spt.update();
    }

    this.startPoint = undefined;
    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = undefined;
    }
    // アイコンボタンの位置更新
    this.updateIconButtons();
  }

  /**
   * ターゲットに合わせて各種パーツリサイズ
   */
  resizeToTarget() {
    // 位置合わせ
    this.syncMeToTarget();

    // 一度回転角度を戻してサイズを計測する
    const motoRot: number = this.target.itemInfo.rotation;
    this.target.rotate(0);
    // SVGSpriteのwidth/heightに書き換え
    let { width } = this.target.spt;
    let { height } = this.target.spt;
    if (this.target instanceof marietta.webcad.item.Stair) {
      width = (this.target as marietta.webcad.item.Stair).patternSpt.width;
      height = (this.target as marietta.webcad.item.Stair).patternSpt.height;
    }

    // ピッカー
    this.dragObj_TL.move(-width / 2, -height / 2);
    this.dragObj_TR.move(width / 2, -height / 2);
    this.dragObj_BL.move(-width / 2, height / 2);
    this.dragObj_BR.move(width / 2, height / 2);
    // アイコンボタンの位置更新
    this.updateIconButtons();

    // 全体Box
    // rectのwidth/heightプロパティに値が代入出来ないので
    // 直接渡すことに（Firefoxのみ値渡しが出来ていたっぽい）
    this.allBox.resize({ width, height });
    this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);

    // 回転角度を元に戻す
    this.target.rotate(motoRot);
    this.rotation = motoRot;
    this.updateTransforms();
  }

  /**
   * コントロールピッカーが移動された
   */
  moveControlPicker(e: MouseEvent, target: marietta.webcad.control.parts.ControlPicker) {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfResize()) return;
    // 開始時のアイテム場所保持
    if (this.startPoint === undefined) {
      if (this.emptySpt === undefined) {
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.target.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }
      this.startPoint = new marietta.core.Point(
        this.emptySpt.mouseX * this.target.spt.scaleX,
        this.emptySpt.mouseY * this.target.spt.scaleY,
      );
    }

    const newPoint: marietta.core.Point = new marietta.core.Point(
      this.emptySpt.mouseX * this.target.spt.scaleX,
      this.emptySpt.mouseY * this.target.spt.scaleY,
    );

    // アイテムの角度分、座標変換を行う
    const r: number = -((this.target.spt.rotation % 360) / 180) * Math.PI;
    const xx: number = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
    const yy: number = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
    newPoint.x = xx;
    newPoint.y = yy;

    // 他のピッカーの制限
    const minGap: number = this.getMinPickerGap();
    switch (target) {
      case this.dragObj_TL:
        if (this.dragObj_BR.y - minGap < newPoint.y) newPoint.y = this.dragObj_BR.y - minGap;
        if (this.dragObj_BR.x - minGap < newPoint.x) newPoint.x = this.dragObj_BR.x - minGap;
        break;
      case this.dragObj_TR:
        if (this.dragObj_BL.y - minGap < newPoint.y) newPoint.y = this.dragObj_BL.y - minGap;
        if (this.dragObj_BL.x + minGap > newPoint.x) newPoint.x = this.dragObj_BL.x + minGap;
        break;
      case this.dragObj_BL:
        if (this.dragObj_TR.y + minGap > newPoint.y) newPoint.y = this.dragObj_TR.y + minGap;
        if (this.dragObj_TR.x - minGap < newPoint.x) newPoint.x = this.dragObj_TR.x - minGap;
        break;
      case this.dragObj_BR:
        if (this.dragObj_TL.y + minGap > newPoint.y) newPoint.y = this.dragObj_TL.y + minGap;
        if (this.dragObj_TL.x + minGap > newPoint.x) newPoint.x = this.dragObj_TL.x + minGap;
        break;
      default: break;
    }

    let w: number;
    let h: number;
    const motoW: number = this.target.itemInfo.width;
    const motoH: number = this.target.itemInfo.height;

    // スケール
    switch (target) {
      case this.dragObj_TL:
        w = this.dragObj_TR.x - newPoint.x;
        h = this.dragObj_BL.y - newPoint.y;
        if (Math.max(motoH, h) - Math.min(motoH, h) > Math.max(motoW, w) - Math.min(motoW, w)) {
          h = (motoH / motoW) * w;
        } else {
          w = (motoW / motoH) * h;
        }
        this.dragObj_TL.move(this.dragObj_TR.x - w, this.dragObj_TL.y = this.dragObj_BL.y - h);
        break;
      case this.dragObj_TR:
        w = newPoint.x - this.dragObj_TL.x;
        h = this.dragObj_BR.y - newPoint.y;
        if (Math.max(motoH, h) - Math.min(motoH, h) > Math.max(motoW, w) - Math.min(motoW, w)) {
          h = (motoH / motoW) * w;
        } else {
          w = (motoW / motoH) * h;
        }
        this.dragObj_TR.move(this.dragObj_TL.x + w, this.dragObj_BL.y - h);
        break;
      case this.dragObj_BL:
        w = this.dragObj_BR.x - newPoint.x;
        h = newPoint.y - this.dragObj_TL.y;
        if (Math.max(motoH, h) - Math.min(motoH, h) > Math.max(motoW, w) - Math.min(motoW, w)) {
          h = (motoH / motoW) * w;
        } else {
          w = (motoW / motoH) * h;
        }
        this.dragObj_BL.move(this.dragObj_BR.x - w, this.dragObj_TL.y + h);
        break;
      case this.dragObj_BR:
        w = newPoint.x - this.dragObj_BL.x;
        h = newPoint.y - this.dragObj_TR.y;
        if (Math.max(motoH, h) - Math.min(motoH, h) > Math.max(motoW, w) - Math.min(motoW, w)) {
          h = (motoH / motoW) * w;
        } else {
          w = (motoW / motoH) * h;
        }
        this.dragObj_BR.move(this.dragObj_BL.x + w, this.dragObj_TR.y + h);
        break;
      default: break;
    }

    // 他のピッカーの整理
    switch (target) {
      case this.dragObj_TL:
        this.dragObj_BL.moveX(target.x);
        this.dragObj_TR.moveY(target.y);
        break;
      case this.dragObj_TR:
        this.dragObj_BR.moveX(target.x);
        this.dragObj_TL.moveY(target.y);
        break;
      case this.dragObj_BL:
        this.dragObj_TL.moveX(target.x);
        this.dragObj_BR.moveY(target.y);
        break;
      case this.dragObj_BR:
        this.dragObj_TR.moveX(target.x);
        this.dragObj_BL.moveY(target.y);
        break;
      default: break;
    }

    // 矩形のサイズ変更
    const rect = {
      x: this.dragObj_BL.x, y: this.dragObj_BL.y, width: (this.dragObj_BR.x - this.dragObj_BL.x), height: (this.dragObj_BR.y - this.dragObj_TR.y),
    };
    this.allBox.resize(rect);
    this.allBox.move(this.dragObj_TL.x + (this.dragObj_TR.x - this.dragObj_TL.x) / 2, this.dragObj_TL.y + (this.dragObj_BL.y - this.dragObj_TL.y) / 2);
    // ターゲットのリサイズ
    this.resizeTarget();
  }

  /**
   * ピッカートランスフォームを更新
   */
  public updatePickers(): void {
    this.dragObj_TL.updateTranslate();
    this.dragObj_TR.updateTranslate();
    this.dragObj_BL.updateTranslate();
    this.dragObj_BR.updateTranslate();
  }
}
